import ReactDOMServer from 'react-dom/server';
// React escapes characters such as apostrophes as numeric entities (&#x27;), and `#` is
// Kendo's template delimiter, so an unescaped entity makes kendo.template throw
// "Invalid template" whenever a translated string contains one.
const NUMERIC_ENTITY = /&#(x?[0-9a-f]+);/gi;
const renderKendoTemplate = (element) => ReactDOMServer.renderToString(element).replace(NUMERIC_ENTITY, '&\\#$1;');
export default renderKendoTemplate;
